import { FormGroup, FormControl } from '@angular/forms';
import { DocumentDetailsService } from './../../../service/document-details.service';
import { NgWizardService } from 'ng-wizard';
import { DocumentTypeService } from './../../../service/document-type.service';
import { ApplicantRequestService } from './../../../service/applicant-request.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import swal from 'sweetalert2';
import {AppConfig} from '../../../shared/common/app.config';
declare var $: any;
declare var scanner: any;


@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
})

export class UploadDocumentComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              public applicantRequestService: ApplicantRequestService,
              public documentTypeService: DocumentTypeService,
              private spinnerService: NgxUiLoaderService,
              private documentDetailsService: DocumentDetailsService,
              private appConfig: AppConfig) { }

  files: File[] = [];
  addedFiles: File[] = [];
  documentTypes: any = [];
  documentDetails: any = []=[];
  documentDetailsList: any = [];
  pageLocationString = 'C://SIDFiles//Document_details';
  selectedImage: any = [];
  savedImages: any = [];
  requestId: number;
  docId: number;
  noOfDoc: number=0;
  selectedDoc: number = 0;
  selectedDocs: any = [];
  uploadedDocs: any = [];
  @Output() response = new EventEmitter<boolean>();
  public valid: boolean = true;
  docIdies: any = [];


  documentUploadFrom = new FormGroup({
    document_type: new FormControl('')
  });

  ngOnInit() {
    this.response.emit(this.valid);
    this.onLoadDocumentType();

    this.route.params.subscribe(
      (param: Params) => {
        this.requestId = param.referanceId;
      }
    );
  }

  onScann() {
    this.scanToJpg(20,'cdca137fcdf64167ac7d24add977928f',
      'localhost',
      'EPIC_SIS',
      '584ce6f070ebf5cf869596413bb2');

  }


  scanToJpg(maxPage, scanid, server, contextPath, session) {
    var val = scanner.isConnectedToScanWebSocket()

    if (val) {

      scanner.scan(function (successful, mesg, response) {
        this.displayImagesOnPage(successful, mesg, response);
        // if(successful) {
        //   var response = $.parseJSON(mesg)
        //   if (response.STATUS) {
        //     var docdata = $.parseJSON(response.RESPONSE);
        //     this.docId = docdata.DOCUMENTID;
        //     this.getSavedDocumentDetailsFromDocumentId(docdata.DOCUMENTID);
        //   }
        // }
        }.bind(this),
        {
          "req_param":
            {
              "scanid": scanid,
              "documentID": "1",
              "server": server,
              "contextPath": contextPath,
              "sessionid": session,
              "username": "test",
              "maxpage": maxPage,
              "uploadUrl": this.appConfig.getConfig('BASE_URL') + "/api/documentscan/upload_scan_doc"
            }
        }
      );

    } else {
      scanner.displayInstallScanAppEnableJavaPopup(true);
    }
    this.refresh();
  }

  displayImagesOnPage(successful, mesg, response) {
    var self = this;
    if(successful){
      var response = $.parseJSON(mesg)
      if (response.STATUS) {
        var docdata = $.parseJSON(response.RESPONSE);
        this.docId = docdata.DOCUMENTID;
        this.docIdies.push(this.docId);
        this.getSavedDocumentDetailsFromDocumentId(docdata.DOCUMENTID);

      }
    }
  }

  refresh(){
    this.uploadedDocs = [];
    this.docIdies.foreach(value=>{
      this.getSavedDocumentDetailsFromDocumentId(value);
    });
  }

  onSubmit(element) {
    // http://localhost:8081/api/applicant/uploadFile
    this.spinnerService.start();
    const formData: FormData = new FormData();
    formData.append('file', element);

    this.applicantRequestService.uploadFiles(formData).subscribe(
      (result: any) => {
        this.spinnerService.stop();
        this.getSavedDocumentDetailsFromDocumentId(result.result);
        this.docId = result.result;
        swal.fire(result.messageStatus , result.message, result.messageClass);
      }, (error) => {
        console.error(error);
        this.spinnerService.stop();
      }
    );
  }


  onSelect(event) {
    this.addedFiles.push(...event.addedFiles);
    this.files = [];
    this.files.push(...event.addedFiles);

    for (var i = 0; i < this.files.length; i++) {
      this.onSubmit(this.files[i]);
    }
  }

  onRemove(event) {
    this.addedFiles.splice(this.addedFiles.indexOf(event), 1);
    this.deleteFile(this.docId);
  }

  deleteFile(event) {
    const id = event.document.documentId;
    const file = event;
    this.applicantRequestService.deleteFile(id).subscribe(
      (result: any) => {
        this.documentDetails.splice(this.documentDetails.indexOf(id),1);
        this.response.emit(true);
        //this.addedFiles.splice(this.addedFiles.indexOf(file), 1);
      }
    )
  }

  onLoadDocumentType() {
    this.documentTypeService.getAllDocumentType().subscribe(
      (result: any) => {
        this.documentTypes = result;
      }
    );
  }

  getSavedDocumentDetailsFromDocumentId(id) {
    this.documentDetailsService.getAllDocumentType(id).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.documentDetails.push(element);
          this.uploadedDocs.push(this.documentDetails);
        });
      }
    );
    if(this.uploadedDocs.length === 0) {
      this.noOfDoc = 1;
    }else {
      this.noOfDoc = this.uploadedDocs.length;
    }

    if((this.addedFiles.length) == this.selectedDoc) {
      this.response.emit(true);
    }else {
      this.response.emit(false);
    }

  }

  onSelectImage(item) {
    if (this.selectedImage.includes(item)) {
      // remove
      const index = this.selectedImage.indexOf(item);

      if (index > -1) {
        this.selectedImage.splice(index, 1);
      }

    } else {
      this.selectedImage.push(item);
      this.selectedDocs.push(this.selectedImage);
      this.selectedDoc = this.selectedDocs.length;
    }

    if((this.addedFiles.length) == this.selectedDocs) {
     this.response.emit(true);
    }else {
      this.response.emit(false);
    }
  }

  saveDocumentTypeAndDetails() {
    const document_type1 = this.documentUploadFrom.controls['document_type'].value;

    if (document_type1 !== '' ) {
      const documentUploadFromData = {
        pageList: this.selectedImage,
        document_type: document_type1,
        requestId: this.requestId
      };

      const copyOfDetails = [...this.documentDetails];
      this.documentDetails = [];
      this.selectedImage = [];

      this.documentDetailsService.saveDocumentTypeAndDetails(documentUploadFromData).subscribe(
        (result: any) => {
          let myMap = new Map();

          copyOfDetails.forEach(element => {
            myMap.set(element.document.documentId, element.document.documentId);
          });

          myMap.forEach(element => {
           this.getSavedDocumentDetailsFromDocumentId(element);
          });

          // result.forEach(element => {
          //   this.savedImages.push(element);
          // });
        }
      );
    } else {
      swal.fire('error' , 'Select a Document Type', 'error');
    }
  }
}
